<template>
  <b-card class="p-1 pt-3 container-complementary-products">
    <h1>Productos adicionales</h1>
    <ul class="mt-1 mb-2">
        <li>En esta sección encontrarás funcionalidades, productos y servicios pensados para maximizar tu experiencia.</li>
    </ul>
    <div class="d-flex col-md-9 ml-3" v-if="loading.first">
      <b-skeleton height="40px" width="30%" class="mt-2 mb-2" />
      <b-skeleton height="40px" width="30%" class="mt-2 mb-2 ml-2" />
    </div>
    <filter-swapper
        v-if="!loading.first"
        :trigger="selectedRows.length === 0"
        id="complementary_products_swapper"
        :buttons="buttons"
        :controlHeightButtons="controlHeight"
        class="ml-3"
    >
        <template #slot1>
            <form-render ref="formRenderFilter" :key="keyFormRender" class="px-0" :fields="fieldsFilter" :buttonSend="buttonSend" :form.sync="formFilter" @send="filterList"
            containerButtonsClass="col-md-4 col-xl-3 mt-2 mb-1 d-flex align-items-center">
                <template #buttons>
                    <b-button variant="outline-light" class="ml-2" v-b-tooltip.hover title="Limpiar filtros" @click="cleanFilter" :disabled="loading.first || disabledClean"><feather-icon icon="RefreshCwIcon"/></b-button>
                </template>
            </form-render>
        </template>
    </filter-swapper>
    <small
      v-if="isAdmin && !payloadFilter.organization"
      class="ml-4 custom-alert-filter-products"
    >Por favor, seleccione una empresa en el filtro para cargar la información.</small>
    <hr class="mr-50 ml-50 mb-0">
    <app-collapse accordion class="row block pr-2 pl-2 collapse-complementary-products">
        <app-collapse-item
            v-for="(item, index) in collapseItems"
            :ref="`collapse-${item.type}`"
            :key="index"
            title=""
            :autoClose="false"
            :customArrowDirection="true"
        >
            <template #header>
                <span class="lead collapse-title">
                    {{ item.label }}
                    <span :class="item.dotClass"></span>
                </span>
            </template>
            <div class="row">
              <card-product
                ref="cardProduct"
                v-for="product in item.products"
                :key="product.id"
                :product="product"
                :userSession="mySession"
                @redirectCompany="redirectCompany"
                @actionButton="actionButton"
                class="mr-1 ml-1 mb-2"
              />
            </div>
        </app-collapse-item>
      </app-collapse>
      <modal-product ref="modalProduct" :product.sync="currentProduct" @requestComplementaryProduct="requestComplementaryProduct"/>
  </b-card>
</template>
<script>
import { mapGetters } from 'vuex'
import BaseServices from '@/store/services/index'
import CardProduct from './components/CardProduct.vue'
import ModalProduct from './components/ModalProduct.vue'
import { EventBus } from '@/@core/utils/eventBus'
export default {
  components: {CardProduct, ModalProduct},
  data () {
    return {
      selectedRows: [],
      buttons: [],
      controlHeight: { class: 'row mb-2 spacing-label-field'},
      loading: {
        first: true
      },
      disabledClean: true,
      keyFormRender: 0,
      fieldsFilter: [],
      buttonSend: {icon: 'SearchIcon', color: 'warning', title: 'Filtrar', disabled: true},
      formFilter: {},
      collapseItems: [
        { label: 'Activos', type: 'active', dotClass: 'table_dot--complementary table_dot--complementary-active' },
        { label: 'Solicitados', type: 'requested', dotClass: 'table_dot--complementary table_dot--complementary-requested' },
        { label: 'Disponibles', type: 'available', dotClass: 'table_dot--complementary table_dot--complementary-available' }
      ],
      payloadFilter: {},
      isAdmin: false,
      currentProduct: {},
      baseService: new BaseServices(this),
      CONDITIONS: Object.freeze({
        OPEN: 'open',
        CLOSE: 'close'
      })
    }
  },
  computed: {
    ...mapGetters({
      mySession: 'getSession',
      shippersByOrganizationSimplifiedQueryParams: 'getShippersByOrganizationSimplifiedQueryParams',
      products: 'getComplementaryProducts'
    })
  },
  watch: {
    mySession () {
      if (this.mySession.id) this.setInitialData()
    },
    shippersByOrganizationSimplifiedQueryParams (value) {
      this.setSelectOptions('shipper', { options: value })
    }
  },
  mounted () {
    this.getAllInitialData()
  },
  methods: {
    getAllInitialData () {
      if (this.mySession.id) this.setInitialData()
    },
    setInitialData() {
      this.initializeRolesAndFields()
      this.firstDataUploadsForCompanies()
      this.completedFirstLoad()
    },
    initializeRolesAndFields() {
      this.setRoles()
      this.setFields()
    },
    firstDataUploadsForCompanies() {
      if (this.isMarketplace || this.isSellerOrEcommerce) {
        this.$loadingAlert({ text: 'Obteniendo datos, por favor espere...', color: 'primary' })
        this.setFilterForNonAdminUsers()
        this.getProducts({ openAllCollapse: true, closeAlert: true })
      }
    },
    completedFirstLoad() {
      this.loading.first = false
      this.handleDisabledButtonsFilter({disabledClean: false, buttonSend: false})
    },
    handleDisabledButtonsFilter({disabledClean, buttonSend}) {
      this.disabledClean = disabledClean
      this.buttonSend.disabled = buttonSend
    },
    setRoles () {
      const role = this.mySession.role
      this.isAdmin = role === 'admin'
      this.isMarketplace = role === 'marketplace'
      this.isSellerOrEcommerce = ['seller', 'ecommerce'].includes(role)
    },
    setFields () {
      const dependency = this.isAdmin ? 'organization' : ''
      this.fieldsFilter = [
        {fieldType: 'FieldInput', name: 'keyword', label: 'Palabra clave', placeholder:'Ingrese palabra clave', containerClass: 'col-md-3 container-info', dependency}
      ]
      if (this.isAdmin || this.isMarketplace) {
        this.setDinamicFieldsByRole(this.mySession.role)
      }
      if (this.isMarketplace) {
        this.loadShippersForMarketplace()
      }
    },
    setDinamicFieldsByRole(role) {
      const dinamicFields = this.getDynamicFieldsByRole(role)
      this.fieldsFilter = [...dinamicFields, ...this.fieldsFilter]
    },
    setFilterForNonAdminUsers () {
      this.payloadFilter = {
        organization: this.mySession.organization.id,
        ...(this.isMarketplace ? {} : { shipper: this.mySession.shipper.id })
      }
    },
    getProducts ({ openAllCollapse = false, closeAlert = false } = {}) {
      const params = {}
      const queryParams = {
        ...this.payloadFilter
      }
      this.$store.dispatch('fetchService', {
        name: 'getComplementaryProducts',
        queryParams,
        params,
        onSuccess: () => this.handleCollapseProducts(openAllCollapse, closeAlert),
        onError: () => this.handleDisabledButtonsFilter({disabledClean: false, buttonSend: false})
      })
    },
    handleCollapseProducts(openAllCollapse, closeAlert) {
      this.updateCollapseItemsProducts(this.products)
      this.closeLoadingAlertIfVisible(closeAlert)
      this.enableFilterButtons()
      this.toggleCollapses(openAllCollapse)
    },
    closeLoadingAlertIfVisible(closeAlert) {
      if (closeAlert) {
        this.m_closeAlertLoading()
      }
    },
    enableFilterButtons() {
      this.handleDisabledButtonsFilter({ disabledClean: false, buttonSend: false })
    },
    toggleCollapses(openAllCollapse) {
      if (this.payloadFilter.keyword) {
        this.toggleCollapsesWithProducts()
      } else if (openAllCollapse) {
        this.toggleCollapseManually(this.CONDITIONS.OPEN)
      }
    },
    updateCollapseItemsProducts(value) {
      this.collapseItems = this.collapseItems.map(item => ({
        ...item,
        products: value?.products?.filter(product => product.type_status === item.type) || []
      }))
    },
    getDynamicFieldsByRole(role) {
      const fieldsByRole = {
        admin: [
          { fieldType: 'FieldSelect', name: 'organization', label: 'Empresa', useLabel: true, containerClass: 'col-md-3 container-info', clearable: true, searchOnType: { fx: this.setOrganizations, nChars: 3, debounce: 600, persistSearch: true }, change: this.changeOrganization },
          { fieldType: 'FieldSelect', name: 'shipper', label: 'Seller', useLabel: true, dependency: 'organization', containerClass: 'hide', useSkeleton: false }
        ],
        marketplace: [
          { fieldType: 'FieldSelect', name: 'shipper', label: 'Seller', useLabel: true, containerClass: 'col-md-3 container-info', useSkeleton: false }
        ]
      }
      return fieldsByRole[role] || []
    },
    loadShippersForMarketplace() {
      const index = this.m_getElementIndex(this.fieldsFilter, 'name', 'shipper')
      this.getShipperByOrganization(index, this.mySession.organization)
    },
    filterList(value) {
      this.handleDisabledButtonsFilter({disabledClean: true, buttonSend: true})
      this.payloadFilter = this.setPayloadFilter(value)
      const openAllCollapse = this.shouldOpenAllCollapse()
      this.getProducts({ openAllCollapse })
    },
    setPayloadFilter(value) {
      let payload = {}
      if (!this.isAdmin) {
        this.setFilterForNonAdminUsers()
        payload = { ...this.payloadFilter }
      }
      Object.keys(value).forEach(key => {
        payload[key] = value[key] && typeof value[key] === 'object' ? value[key].id : value[key]
      })
      return payload
    },
    shouldOpenAllCollapse() {
      return (this.payloadFilter.organization || this.payloadFilter.shipper) && !this.payloadFilter.keyword
    },
    cleanFilter () {
      this.formFilter = {}
      this.payloadFilter = {}
      if (this.isAdmin) {
        this.resetFiltersAdmin()
      } else {
        this.resetFiltersNoAdmin()
      }
      this.keyFormRender++
    },
    resetFiltersAdmin() {
      const index = this.m_getElementIndex(this.fieldsFilter, 'name', 'shipper')
      this.updateFieldShipper(index, { containerClass: 'hide', options: [] })
      this.updateCollapseItemsProducts({ products: [] })
      this.toggleCollapseManually(this.CONDITIONS.CLOSE)
    },
    resetFiltersNoAdmin () {
      this.handleDisabledButtonsFilter({disabledClean: true, buttonSend: true})
      this.setFilterForNonAdminUsers()
      this.getProducts({ openAllCollapse: true })
    },
    setOrganizations(value) {
      return this.setPlaces(value)
    },
    async setPlaces(value) {
      const queryParams = {
        name: value
      }
      return await this.baseService.callService('getOrganizationsGlobal', queryParams)
        .then(resp => {
          return resp.data.map(el => {
            const text = el.organization_type.id === 1 ? `${el.name} (M)` : el.name
            return {...el, text}
          })
        })
        .catch(err => { return err })
    },
    changeOrganization (name, value) {
      const index = this.m_getElementIndex(this.fieldsFilter, 'name', 'shipper')
      if (value?.id) {
        this.handleViewFieldShipper(index, value)
        this.formFilter.shipper = null
        if (value.organization_type.id === 1) {
          this.getShipperByOrganization(index, this.formFilter.organization)
        }
        return
      }
      this.updateFieldShipper(index, { containerClass: 'hide', options: [] })
      this.resetFormCompanies()
    },
    resetFormCompanies () {
      this.formFilter = {
        ...this.formFilter,
        shipper: null,
        organization: null
      }
      this.keyFormRender++
    },
    handleViewFieldShipper (index, value) {
      const isType2 = value.organization_type.id === 2
      this.updateFieldShipper(index, {
        containerClass: isType2 ? 'hide' : 'col-md-3 container-info',
        options: []
      })
    },
    getShipperByOrganization (index, organization) {
      const queryParams = {}
      const params = {
        organization_id: organization?.id || 0
      }
      this.loadingFieldShipper(index, true)
      this.$store.dispatch('fetchService', { name: 'getShippersByOrganizationSimplifiedQueryParams', queryParams, params, onSuccess: () => this.loadingFieldShipper(index, false)})
    },
    updateFieldShipper(index, { containerClass, options }) {
      if (index !== -1) {
        Object.assign(this.fieldsFilter[index], { containerClass, options })
      }
    },
    loadingFieldShipper(index, useSkeleton) {
      if (index !== -1) {
        this.fieldsFilter[index].useSkeleton = useSkeleton
      }
    },
    setSelectOptions (name, { options }) {
      const index = this.m_getElementIndex(this.fieldsFilter, 'name', name)
      if (index !== -1) {
        this.fieldsFilter[index].options = options
      }
    },
    toggleCollapseManually(action) {
      const toggleMethod = action === this.CONDITIONS.OPEN ? 'openCollapseManually' : 'closeCollapseManually'
      this.collapseItems.forEach(item => {
        this.$refs[`collapse-${item.type}`][0][toggleMethod]()
      })
    },
    toggleCollapsesWithProducts () {
      this.$nextTick(() => {
        this.collapseItems.forEach((item, index) => {
          const collapseRef = this.$refs[`collapse-${item.type}`][0]
          if (collapseRef) {
            if (item.products && item.products.length > 0) {
              collapseRef.openCollapseManually()
            } else {
              collapseRef.closeCollapseManually()
            }
          }
        })
      })
    },
    redirectCompany () {
      const id = this.payloadFilter.shipper || this.payloadFilter.organization
      // Nueva pestaña
      this.m_openWinBlank(`/companies/${id}?tab=webhooks`)
      // Misma pestaña
      //this.$router.push({ name: 'company-details', params: { id }, query: { tab: 'webhooks' } })
    },
    requestComplementaryProduct (product) {
      this.actionButton('request', product)
    },
    actionButton (type, product) {
      const actions = {
        more_info: () => this.viewWhatsApp(product),
        request: () => this.requestProduct(product),
        active: () => this.activeProduct(product)
      }
      actions[type]()
    },
    resetLoadingBtnCard (product) {
      this.$refs.cardProduct.forEach(card => {
        if (card.product.id === product.id) {
          card.loadingBtn = false
        }
      })
    },
    viewWhatsApp (product) {
      this.resetLoadingBtnCard(product)
      this.currentProduct = product
      this.$bvModal.show('modalProduct')
    },
    requestProduct (product) {
      this.$store.dispatch('fetchService', {
        name: 'requestComplementaryProduct',
        params: { id: product.id },
        hideAlert: true,
        onSuccess: () => this.requestProductSuccess(product),
        onError: (e) => this.requestProductError(e, product)
      })
    },
    activeProduct (product) {
      this.$store.dispatch('fetchService', {
        name: 'activeComplementaryProduct',
        params: { id: product.id },
        hideAlert: true,
        onSuccess: () => this.activeProductSuccess(product),
        onError: (e) => this.activeProductError(e, product)
      })
    },
    requestProductSuccess (product) {
      this.$newSuccess('Excelente', `El producto ${product.title} ha sido solicitado correctamente`, 'medium')
      this.resetLoadingBtnCard(product)
      this.getProducts()
      if (product.id === 1) this.$bvModal.hide('modalProduct')
    },
    activeProductSuccess (product) {
      this.$newSuccess('Excelente', `El producto ${product.title} ha sido activado correctamente`, 'medium')
      this.resetLoadingBtnCard(product)
      this.getProducts()
    },
    requestProductError (err, product) {
      this.$newError(`Ocurrio un error en el producto ${product.title}.`, err.message, 'medium')
      this.resetLoadingBtnCard(product)
      if (product.id === 1) EventBus.$emit('handleDisabledButtonSaved', false)
    },
    activeProductError (err, product) {
      this.$newError(`Ocurrio un error en el producto ${product.title}.`, err.message, 'medium')
      this.resetLoadingBtnCard(product)
    }
  }
}
</script>
<style lang='scss'>
.container-complementary-products h1 {
  font-size: 20px;
}
.custom-alert-filter-products {
  opacity: 0.8;
}
.table_dot--complementary {
  position: relative;
  display: inline-block;
  height: 10px;
  width: 10px;
  border-radius: 50%;
  margin-left: 0.5rem;
}
.table_dot--complementary-active {
  background-color:#1E8E3E
}
.table_dot--complementary-requested {
  background-color:#31AEE4
}
.table_dot--complementary-available {
  background-color:#F8C83C
}
.collapse-complementary-products {
    .card-header {
      justify-content: flex-start;
    }

    [data-toggle='collapse'] {
      &:after {
        position: initial;
        margin-top: 0;
        margin-left: 0.5rem;
      }

    }
  }
</style>